import { getContext } from '@picsart/miniapps-sdk';
import { APP_API_URL, defaultConfig } from '../constants';
import NetworkError from './networkError';

async function updateImageVisibility(serviceConfig: any, id: string, promptId: string, visible = true): Promise<void> {
  return getContext()
    .utils.api.fetch(`${APP_API_URL}${serviceConfig.visibility_service_url}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        platform: 'web',
        aiBaseServiceUrl: serviceConfig.visibility_path,
      },
      body: JSON.stringify({ image_id: id, visibility: visible, prompt_id: promptId }),
    })
    .then(res => Promise.all([res, res.json()]))
    .then(([res, body]) => {
      if (!res.ok) {
        const {
          errors: { service_error: serverError },
        } = defaultConfig;

        throw new NetworkError(serverError);
      }

      return body;
    });
}

export default updateImageVisibility;
